import { render, staticRenderFns } from "./view.vue?vue&type=template&id=16bdd8b8"
import script from "./view.js?vue&type=script&lang=js&external"
export * from "./view.js?vue&type=script&lang=js&external"
import style0 from "./view.vue?vue&type=style&index=0&id=16bdd8b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports